module.exports = __webpack_public_path__ + "static/img/downloadpopupgold2.e8a70ca7.webp";